
import React from 'react';
import VideoPlayer from '@/components/VideoPlayer';
import DailyContent from '@/components/DailyContent';
import Gamification from '@/components/Gamification';
import CompletedDayNotification from './CompletedDayNotification';
import LessonCheckInHandler from './LessonCheckInHandler';
import ProgramCheckIn from '@/components/ProgramCheckIn';
import { Lesson } from '@/data/lessons';

interface LessonContentProps {
  currentLesson: Lesson;
  dayNumber: number;
  isDayCompleted: boolean;
  completedDay: boolean;
  earnedPoints: number;
  setEarnedPoints: React.Dispatch<React.SetStateAction<number>>;
  setCompletedDay: React.Dispatch<React.SetStateAction<boolean>>;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
  goToNextDay: () => void;
  userProgressStreak: number;
  userProgressPoints: number;
  showFinalProgramCheckIn?: boolean;
}

const LessonContent: React.FC<LessonContentProps> = ({ 
  currentLesson, 
  dayNumber, 
  isDayCompleted, 
  completedDay, 
  earnedPoints, 
  setEarnedPoints, 
  setCompletedDay, 
  setError, 
  goToNextDay, 
  userProgressStreak, 
  userProgressPoints,
  showFinalProgramCheckIn = false
}) => {
  // Handle completion of the program check-in
  const handleProgramCheckInComplete = () => {
    // We don't need to do anything special here as the program check-in component
    // handles all the badge and points logic
    setCompletedDay(true);
  };

  return (
    <>
      <VideoPlayer videoId={currentLesson.videoId} title={currentLesson.title} />
      <DailyContent lesson={currentLesson} />
      
      {/* Gamification component to show current progress and animate on completion */}
      <div className="my-8">
        <Gamification 
          streak={userProgressStreak} 
          points={userProgressPoints}
          completedDay={completedDay}
          earnedPoints={earnedPoints}
          currentDay={dayNumber}
          lessonsCompleted={isDayCompleted ? dayNumber : dayNumber - 1}
        />
      </div>
      
      {/* Final program completion check-in */}
      {showFinalProgramCheckIn ? (
        <div className="mt-8">
          <ProgramCheckIn day={30} onComplete={handleProgramCheckInComplete} />
        </div>
      ) : isDayCompleted ? (
        <CompletedDayNotification 
          dayNumber={dayNumber} 
          goToNextDay={goToNextDay} 
        />
      ) : (
        <LessonCheckInHandler
          currentLesson={currentLesson}
          dayNumber={dayNumber}
          isDayCompleted={isDayCompleted}
          earnedPoints={earnedPoints}
          setEarnedPoints={setEarnedPoints}
          setCompletedDay={setCompletedDay}
          setError={setError}
        />
      )}
    </>
  );
};

export default LessonContent;
